import React, { useEffect, useRef, useState } from 'react';
import { BadgeCheck, Star } from 'lucide-react';
import { stats, serviceStandards } from '../mock';

function useCountUp(target, active, decimals = 0) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    let raf; const dur = 1900; const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(target * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, target]);
  return decimals ? val.toFixed(decimals) : Math.floor(val).toLocaleString();
}

function StatItem({ s, active }) {
  const display = useCountUp(s.value, active, s.isRating ? 1 : 0);
  return (
    <div className="relative px-1 sm:px-2 py-3 sm:py-4">
      <div className="flex items-baseline gap-1">
        <span className="font-display text-3xl sm:text-5xl lg:text-6xl font-extrabold text-[#16150f] tracking-tight">{display}</span>
        <span className="text-[#ff5a1f] text-xl sm:text-3xl font-extrabold">{s.suffix}</span>
      </div>
      {s.isRating && (
        <div className="flex gap-0.5 mt-2">{[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#ff5a1f] text-[#ff5a1f]" />)}</div>
      )}
      <p className="mt-3 text-sm font-semibold text-[#16150f]">{s.label}</p>
      <p className="text-xs text-[#8a8578] mt-0.5">{s.sub}</p>
    </div>
  );
}

export default function TrustStats() {
  const ref = useRef(null);
  const [active, setActive] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setActive(true); obs.disconnect(); } }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="trust" ref={ref} className="py-12 lg:py-24">
      <div className="section-pad max-w-[1440px] mx-auto">
        <div className="card-elevated rounded-[1.4rem] sm:rounded-[2rem] p-5 sm:p-8 lg:p-12">
          <div className="flex items-center justify-between flex-wrap gap-4 mb-8">
            <div>
              <span className="eyebrow"><span className="dot" /> Why Owners Trust VINYLED</span>
              <p className="mt-4 text-[#5a5548] max-w-lg">Professional protection, premium materials and proven automotive experience in Bengaluru.</p>
            </div>
            <span className="inline-flex items-center gap-2 text-[0.62rem] font-semibold tracking-widest text-[#16150f] border border-black/10 rounded-full px-3 py-1.5"><BadgeCheck className="w-3.5 h-3.5 text-[#ff5a1f]" /> VERIFIED SERVICE</span>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-4 lg:gap-y-0 lg:divide-x divide-black/8">
            {stats.map((s, i) => (
              <div key={s.label} className={i === 0 ? '' : 'lg:pl-8'}>
                <StatItem s={s} active={active} />
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-black/8 overflow-hidden">
            <div className="flex animate-marquee-left w-max">
              {[...serviceStandards, ...serviceStandards].map((item, i) => (
                <span key={i} className="flex items-center gap-2 pr-8 text-sm text-[#6b6558] whitespace-nowrap">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#ff5a1f]" /> {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
